import { render } from "./CommonRequire.vue?vue&type=template&id=769abf78"
const script = {}

import "./CommonRequire.vue?vue&type=style&index=0&id=769abf78&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__